(function($$, $) {

  //
  // FACEBOOK CONNECT OBJECT
  // This object encapsulates all information related to Facebook JS SDK
  //
  function FacebookConnect(config) {
    this.config = config;
    this.activityQueue = [];
    this.ssFbConnectReady = true;
    this.fbErrorCodes = {
      INVALID_ACCESS_TOKEN : 190,
      REQUIRES_EXTENDED_PERMISSIONS : 200
    };
    this.linkFbProfileResponse = {
      PROFILE_LINKED : 1,
      NOT_LOGGED_IN : 2,
      USER_ALREADY_EXISTS : 3,
      NO_PUBLISH_PERMISSIONS : 4
    };
    this.perms = {
      scope: $$.fb_permissions,
      return_scopes: true
    };
    this.emailRerequestPerm = {
      scope: 'email',
      return_scopes: true,
      auth_type: 'rerequest'
    };
    this.reAuthPerm = {
      return_scopes: true,
      auth_type: 'reauthenticate'
    };
  }

  //
  // Initialization
  //
  FacebookConnect.prototype.init = function() {
    this.loadScript();
  };

  //
  // Load and setup the Facebook JS script
  //
  FacebookConnect.prototype.loadScript = function() {
    window.fbAsyncInit = $.proxy(function() {
      window.FB.init($$.fb_init_params);
      $(document).trigger('fbinitialized');
      this.onFbInitialized();
    }, this);

    $('body').append('<div id="fb-root"></div>');

    var e = document.createElement('script');
    e.src = document.location.protocol + $$.fb_sdk_url;
    e.id = 'facebook-jssdk';
    e.async = true;
    document.getElementById('fb-root').appendChild(e);
  };

  //
  // Method called after FB has been initialized
  //
  FacebookConnect.prototype.onFbInitialized = function() {
    // When facebook sdk is initialized, activate fblogin button
    // on login/signup pages
    $('#fb-login').removeClass('disabled');
    if (window.FB && $$.slideshow !== undefined) {
      window.FB.Event.subscribe('edge.create', function (targetUrl) {
        _gaq.push(['_trackSocial', 'facebook', 'like', targetUrl]);
        _gaq.push(['_trackEvent', 'bigfoot_slideview', 'viralsharefacebook']);
      });
    }
  };

  //
  // Show educational banner to users and re-request for email permission
  // after they declined the first time
  //
  // @Todo : Modify the logic to use CSS to change the html in place for performance optimization (SLDSHR-424)
  FacebookConnect.prototype.showEmailRerequestBanner = function(fbLoginHtml) {
    $('.j-fb-email-rerequest-banner').removeClass('hide').slideDown();
    $$.fbConnect.fbLoginHtml = fbLoginHtml;
    $('#fb-login').empty().text($$.utils.i18n("fbconnect.connecting")).addClass('disabled');
  };

  //
  // Close the email re-request banner
  //
  FacebookConnect.prototype.closeEmailRerequestBanner = function() {
    $('.j-fb-email-rerequest-banner').hide();
    $('#fb-login').html($$.fbConnect.fbLoginHtml).removeClass('disabled');
  };

  //
  // Trigger FB's email permission rerequest dialog after users confirm in re-request banner
  //
  FacebookConnect.prototype.emailRerequestBannerCallback = function() {
    var itemLocation = 'login';
    window.fromSource = getUrlVar('from_source') || encodeURIComponent('/');
    $('#j-fb-login-indicator').show();
    var perms = $$.fbConnect.emailRerequestPerm;

    // @Todo : Refactor to use a helper method for the same codes in bindEvents (SLDSHR-404)
    window.FB && window.FB.login(function(response) {
      if (response) {
        if (response.authResponse) {
          if (response.authResponse.grantedScopes.indexOf("email") == -1) {
            $$.fbConnect.showEmailRerequestBanner($$.fbConnect.fbLoginHtml);
          } else {
            if($('.j-fb-email-rerequest-banner').length && $('.j-fb-email-rerequest-banner').is(':visible')) {
              $('.j-fb-email-rerequest-banner').hide();
            }
            if ($$.user.loggedin) {
              if (!$$.user.is_valid_fbuser) {
                $.post('/fbconnect/link_facebook_profile',
                  { access_token : response.authResponse.accessToken,
                    fb_user_id : response.authResponse.userID,
                    granted_perms : response.authResponse.grantedScopes },
                  function(data) {
                    $$.fbConnect.fbconnect_login_redirect_link(data);
                  },
                  'json');
              }
            } else {
              $.post('/fbconnect/fb_login',
              {},
              function(data) {
                $$.fbConnect.ssFbConnect('/fbconnect/create_account_or_login',
                  { access_token : response.authResponse.accessToken,
                    fb_user_id : response.authResponse.userID,
                    login_source : window.loginSource,
                    granted_perms : response.authResponse.grantedScopes
                  }, function(data) {
                    $$.fbConnect.fbconnect_login_redirect(data, itemLocation);
                  });
              },
              'json');
            }
          }
        } else {
          $('#j-fb-login-indicator').hide();
        }
      } else {
        $('#j-fb-login-indicator').hide();
      }
    },
    perms);
  };

  //
  // Show educational modal to users and re-request for email permission
  // after they declined the first time
  //
  FacebookConnect.prototype.showEmailRerequestModal = function() {
    if ($('#fblogin-modal-cta').length) {
      // fblogin-modal-cta: Foundation layout
      $('#fblogin-modal-cta').replaceWith($('.j-fb-email-rerequest-html').html());
    } else {
      // fb-login-modalbox: Non Foundation layout
      $('#fb-login-modalbox').replaceWith($('.j-fb-email-rerequest-html').html());
    }
  };

  //
  // Trigger FB's email permission rerequest dialog after users confirm in re-request modal
  //
  FacebookConnect.prototype.emailRerequestModalCallback = function(ss_fb_connect_callback) {
    window.fromSource = window.fromSource || getUrlVar('from_source');
    var itemLocation = 'fancybox';
    $('#j-fb-modalbox-indicator').show();
    var perms = $$.fbConnect.emailRerequestPerm;
    //Facebook SDK should be ready before this block executes
    // @Todo : Refactor to use a helper method for the same codes in modalLoginFbButtonClickCallback (SLDSHR-404)
    window.FB && window.FB.login(function(response) {
      if (response && response.authResponse) {
        if (response.authResponse.grantedScopes.indexOf("email") == -1) {
          $$.fbConnect.showEmailRerequestModal();
        } else {
          $$.fbConnect.ssFbConnect('/fbconnect/create_account_or_login' + ($$.isDownloadUrl() ? '?from_page=download' : ''),
            { access_token : response.authResponse.accessToken,
              fb_user_id : response.authResponse.userID,
              login_source : window.loginSource
            }, function(data) {
              if (typeof ss_fb_connect_callback !== 'undefined') {
                ss_fb_connect_callback(data, itemLocation);
              }
            }
          );
        }
      }
      $('#j-fb-modalbox-indicator').hide();
    },
    perms);
  };

  //
  // Facebook Unlink accounts callback
  //
  FacebookConnect.prototype.fbconnect_delink_callback = function(data) {
    window.location.reload();
  };

  //
  // Modal login window callback after facebook login
  // Post message to the login iframe popin
  //
  FacebookConnect.prototype.fbconnect_login_redirect_from_iframe = function(data, itemLocation) {
    var fromSource = $('#target_url').val();
    var message = 'fbconnectDefault';
    switch (data.status) {
    case 1:
      /*A new user has been created*/
      $$.ga('Signup', 'fb_login', 'fb_signup_from_'+ itemLocation);
      message = 'fbconnectNewUser';
      break;
    case 2:
      /* User is existing ss user */
      $$.ga('Login', 'fb_login', 'fb_ss_user_from_'+ itemLocation);
      message = 'fbconnectExistingUser';
      break;
    case 3:
      /*The user already had a facebook linked account*/
      /*Handle the logout page*/
      $$.ga('Login', 'fb_login', 'fb_login_from_' + itemLocation);
      message = 'fbconnectExistingUserWithLinkedAccount';
      break;
    case 4:
      /*Failed*/
      message = 'fbconnectFailed';
      break;
    case 5:
      /*Suspended User*/
      message = 'fbconnectSuspendedUser';
      break;
    }
    $.postMessage(message, fromSource, parent);
  };

  /* Handles redirect logic when a logged in slideshare
  user links his account to facebook */
  FacebookConnect.prototype.fbconnect_login_redirect_link = function(data) {
    $('#j-fb-topnav-indicator').hide();
    $('#j-fb-login-indicator').hide();
    switch (data.status) {
    case this.linkFbProfileResponse.PROFILE_LINKED:
      /* Success */
      window.location.reload();
      break;
    case this.linkFbProfileResponse.USER_ALREADY_EXISTS:
      /*User already exists this facebook login*/
      $('#page-error').append($$.utils.i18n('fbconnect.connect.error')).show();
      break;
    default:
      $('#page-error').append($$.utils.i18n('fbconnect.connect.default_error')).show();
    }
  };

  FacebookConnect.prototype.fbconnect_login_redirect = function(data, itemLocation) {
    // Modal login window in upload page raises a ga call when fb login/signup is successful
    var escaped_window_location = encodeURIComponent(window.location.href);
    var fromSource = window.fromSource,
      fromType = window.fromType || getUrlVar('from');
    if((window.location.pathname.startsWith("/upload")) &&
      (data.status === 1 || data.status === 2 || data.status === 3)) {
      $$.ga('Upload', 'fb_login_successful');
      escaped_window_location = escaped_window_location.replace("loggedout_","loggedin_loggedout_");
    }
    switch (data.status) {
    case 1:
      /*A new user has been created*/
      $$.ga('Signup', 'fb_login', 'fb_signup_from_' + itemLocation);
      if (typeof fromSource != "undefined") {
        window.location.replace("/fbconnect/landingpage?from=" + fromSource);
      } else {
        window.location.replace("/fbconnect/landingpage?from=" + escaped_window_location);
      }
      break;
    case 2:
      /* User is existing ss user */
      $$.ga('Login', 'fb_login', 'fb_ss_user_from_' + itemLocation);
      if (typeof fromSource != "undefined") {
        window.location.replace("/fbconnect/landingpage?from=" + fromSource);
      } else {
        window.location.replace("/fbconnect/landingpage?from=" + escaped_window_location);
      }
      break;
    case 3:
      /*The user already had a facebook linked account*/
      /*Handle the logout page*/
      $$.ga('Login', 'fb_login', 'fb_login_from_'+itemLocation);
      var decodedURL = decodeURIComponent(fromSource);

      if (getUrlVars().from_logout !== undefined && typeof fromType == "undefined") {
        window.location.replace('/');
      }else if(window.location.pathname.startsWith("/upload")){
        window.location.replace(window.location.href.replace("loggedout_","loggedin_loggedout_"));
        return false;
      } else if (fromSource &&
        fromSource.length > 1 &&
        isInternalRedirect(fromSource) &&
        window.location.href !== decodedURL) {
        window.location.href = decodedURL;
      } else {
        window.location.reload();
      }
      break;
    case 4:
      /*Failed*/
      $('.j-alert').empty().text($$.utils.i18n("fbconnect.login.unsuccessful"));
      $('.j-alert').removeClass('hide');
      break;
    case 5:
      /*Suspended User*/
      $('.j-alert').html(data.message);
      $('.j-alert').removeClass('hide');
      break;
    case 8:
      if (typeof fromSource != "undefined") {
        window.location.replace("/login/li_connect?from_source=" + fromSource);
      } else {
        window.location.replace("/login/li_connect?from_source=" + escaped_window_location);
      }
      break;
    default:
      window.location.reload();
    }
  };

  //
  // Modal Login Facebook Button Click Callback
  //
  FacebookConnect.prototype.modalLoginFbButtonClickCallback = function(ss_fb_connect_callback) {
    window.fromSource = window.fromSource || getUrlVar('from_source');
    var itemLocation = 'fancybox';
    $('#j-fb-modalbox-indicator').show();
    var perms = $$.fbConnect.perms;
    //Facebook SDK should be ready before this block executes
    // @Todo : Refactor to use a helper method for the same codes in emailRerequestModalCallback (SLDSHR-404)
    window.FB && window.FB.login(function(response) {
      if (response && response.authResponse) {
        if (response.authResponse.grantedScopes.indexOf("email") == -1) {
          $$.fbConnect.showEmailRerequestModal();
        } else {
          $$.fbConnect.ssFbConnect('/fbconnect/create_account_or_login' + ($$.isDownloadUrl() ? '?from_page=download' : ''),
            { access_token : response.authResponse.accessToken,
              fb_user_id : response.authResponse.userID,
              login_source : window.loginSource
            }, function(data) {
              if (typeof ss_fb_connect_callback !== 'undefined') {
                ss_fb_connect_callback(data, itemLocation);
              }
            }
          );
        }
      }
      $('#j-fb-modalbox-indicator').hide();
    },
    perms);
  };

  //
  // Bind events
  //
  FacebookConnect.prototype.bindEvents = function() {

    //-- MODAL LOGIN
    if (!$$.user.loggedin) {
      // fb-login-modalbox: Non Foundation layout
      // fblogin-modal-cta: Foundation layout
      $('body').on('click', '#fb-login-modalbox, #fblogin-modal-cta', function() {
        $$.fbConnect.modalLoginFbButtonClickCallback($.proxy($$.fbConnect.fbconnect_login_redirect_from_iframe, $$.fbConnect));
      });

      $('body').on('click', '.fb-email-rerequest-modal-cta', function() {
        $$.fbConnect.emailRerequestModalCallback($.proxy($$.fbConnect.fbconnect_login_redirect_from_iframe, $$.fbConnect));
      });
    }

    //-- LOGIN / SIGNUP PAGE AND CONNECT TO FACEBOOK
    // These are also used on connect to facebook page
    // so they should not be put in the !$$.user.loggedin check
    $('body').on('click', '.fb-email-rerequest-banner-cta', function() {
      $$.fbConnect.emailRerequestBannerCallback();
    });

    $('body').on('click', '.j-fb-email-rerequest-close', function() {
      $$.fbConnect.closeEmailRerequestBanner();
    });

    //-- USER SHARING SETTINGS

    // Unlink FB from Edit Sharing Settings
    $('#j-delink-fb').on('click', function(e) {
      e.preventDefault();
      $.post('/fbconnect/delink_facebook_profile', {}, $$.fbConnect.fbconnect_delink_callback, 'json');
    });

    //-- LOGIN/SIGNUP PAGE

    // Bind fb login button
    var trackingId = $('#fb-login').attr('data-tracking-id');

    $('#fb-login').click(function(e) {
      if ($(this).hasClass('disabled')){
        return;
      }

      if ($(this).hasClass('facebook-disabled')) {
        return;
      }
      var itemLocation = 'login';
      var fbLoginHtml = $(this).html();
      e.preventDefault();
      window.fromSource = getUrlVar('from_source') || encodeURIComponent('/');
      $('#j-fb-login-indicator').show();
      if (!$(this).hasClass("fb-login-new")) {
        $(this).empty().text($$.utils.i18n("fbconnect.connecting")).addClass("disabled");
      }

      var isReAuth = getUrlVar('re_auth') !== undefined;
      var perms = isReAuth ? $$.fbConnect.reAuthPerm : $$.fbConnect.perms;
      // @Todo : Refactor to use a helper method for the same codes in emailRerequestBannerCallback (SLDSHR-404)
      window.FB && window.FB.login(function(response) {
        if (response) {
          if (response.authResponse) {
            if (!isReAuth && response.authResponse.grantedScopes.indexOf("email") == -1) {
              $$.fbConnect.showEmailRerequestBanner(fbLoginHtml);
            } else {
              if($('.j-fb-email-rerequest-banner').length && $('.j-fb-email-rerequest-banner').is(':visible')) {
                $('.j-fb-email-rerequest-banner').hide();
              }
              if ($$.user.loggedin && !isReAuth) {
                if (!$$.user.is_valid_fbuser) {
                  $.post('/fbconnect/link_facebook_profile',
                    { access_token : response.authResponse.accessToken,
                      fb_user_id : response.authResponse.userID,
                      granted_perms : response.authResponse.grantedScopes },
                    function(data) {
                      $$.fbConnect.fbconnect_login_redirect_link(data);
                    },
                    'json');
                }
              } else {
                $.post('/fbconnect/fb_login',
                {},
                function(data) {
                  if (isReAuth) {
                    if (!$$.user.is_valid_fbuser ||
                        response.authResponse.grantedScopes === undefined ||
                        $$.user.fb_userid != response.authResponse.userID) {
                      $('.j-alert').empty().text($$.utils.i18n('fbconnect.login.no_match'));
                      $('.j-alert').removeClass('hide').show();
                      $$.ga('Login', 'fb_login', 'fb_re_auth_failure');
                      return;
                    }
                  }
                  $$.fbConnect.ssFbConnect('/fbconnect/create_account_or_login',
                    { access_token : response.authResponse.accessToken,
                      fb_user_id : response.authResponse.userID,
                      login_source : window.loginSource,
                      granted_perms : response.authResponse.grantedScopes,
                      tracking_id: trackingId
                    }, function(data) {
                      $$.fbConnect.fbconnect_login_redirect(data, itemLocation);
                    });
                },
                'json');
              }
            }
          } else {
            $('#j-fb-login-indicator').hide();
          }
        } else {
          $('#j-fb-login-indicator').hide();
        }
      },
      perms);
    });
  };

  //
  // Method to make call to Facebook controller
  //
  FacebookConnect.prototype.ssFbConnect = function(url, params, callback) {
    if (this.ssFbConnectReady !== true) {
      return;
    }
    this.ssFbConnectReady = false;
    $.post(url, params, function(data) {
      this.ssFbConnectReady = true;
      callback(data);
    }, 'json');
  };

  // Set SlideShare methods for compatibility
  $$.setup_fbconnect_interaction = function() {
    $$.fbConnect.bindEvents();
  };

  $$.fbConnect = new FacebookConnect();

  // Initialize
  $(window).load(function() {
    $$.fbConnect.init();
  });

})(window.slideshare_object, jQuery);
